import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Button } from "../../ui/button";
import { Plus } from "lucide-react";

export const ExtraForm = ({ form, setForm, editingId, saving, onSubmit, onCancel }) => (
  <div className="border-t pt-4 space-y-3">
    <p className="text-sm font-medium">{editingId ? "Editar extra" : "Nuevo extra"}</p>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <div>
        <Label>Nombre del extra</Label>
        <Input
          data-testid="admin-extra-form-label"
          value={form.label}
          onChange={(e) => setForm((f) => ({ ...f, label: e.target.value }))}
          placeholder="Ej. Dron aéreo"
        />
      </div>
      <div>
        <Label>Precio (MXN)</Label>
        <Input
          data-testid="admin-extra-form-price"
          type="number"
          value={form.price}
          onChange={(e) => setForm((f) => ({ ...f, price: e.target.value }))}
          placeholder="Ej. 900"
        />
      </div>
    </div>
    <div className="flex gap-2">
      <Button data-testid="admin-extra-submit-button" onClick={onSubmit} disabled={saving}>
        <Plus size={16} className="mr-1" /> {editingId ? "Guardar cambios" : "Agregar extra"}
      </Button>
      {editingId && (
        <Button data-testid="admin-extra-cancel-edit" variant="outline" onClick={onCancel}>Cancelar</Button>
      )}
    </div>
  </div>
);
